module.exports = __webpack_public_path__ + "img/car_00043.7f7e088e.jpg";